import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100%',
      display: 'flex',
      gap: theme.spacing(1),
    },
    content: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    header: {
      marginTop: theme.spacing(0.5),

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    position: {
      fontSize: theme.typography.pxToRem(22),
      lineHeight: theme.typography.pxToRem(32),
      fontWeight: theme.typography.fontWeightBold,
    },
    comparisonSetButton: {
      display: 'inline-block',
      maxWidth: 135,
    },
    truncatedText: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    settingsButton: {
      color: COLORS.gray.gray40,
      padding: theme.spacing(0.5),
      marginLeft: 'auto',
      '&:hover, &:active': {
        backgroundColor: 'unset',
      },
    },
    settingsIcon: {
      fontSize: theme.typography.pxToRem(16),
    },
    footer: {
      marginTop: theme.spacing(1),
      display: 'flex',
      columnGap: theme.spacing(0.5),
      alignItems: 'center',
    },
    dataSource: {
      maxWidth: 230,
      color: COLORS.gray.gray30,
    },
    userGoal: {
      color: COLORS.gray.gray30,
    },
    bullet: {
      color: COLORS.gray.gray40,
    },
    tooltip: {
      maxWidth: 353,
    },
    tooltipHeader: {
      marginBottom: theme.spacing(0.5),
    },
    tooltipContent: {
      padding: theme.spacing(1, 0),
    },
  }),
  { name: 'ConnectedBenchmark' }
);
